module.exports = __webpack_public_path__ + "img/GTA.c4fb57de.png";